// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — settings-receipt.styled.classic.js, новая — settings-receipt.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './settings-receipt.styled.classic';
import * as cp from './settings-receipt.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const TablePlace = isCp ? cp.TablePlace : classic.TablePlace;
export const TopPlace = isCp ? cp.TopPlace : classic.TopPlace;
